import React from "react";

const CookiesSummarySnippet = () => (
  <p>
    Мы используем необходимые файлы cookie и аналогичные технологии для
    обеспечения работы сайта UNBL. Кроме того, мы хотели бы использовать их для
    оптимизации работы сайта, отслеживая, как вы им пользуетесь. Эти файлы будут
    установлены только в том случае, если вы дадите на это согласие.
  </p>
);

export default CookiesSummarySnippet;
